'use strict';

module.exports = {
  open: require('./open')
};



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web/lib/frame-service/external/popup/index.js
// module id = 535
// module chunks = 1